/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  
  const tabLinks = document.querySelectorAll(".tab-link");
  const tabContents = document.querySelectorAll(".tab-content-new");

  tabLinks.forEach(tab => {
    tab.addEventListener("click", function (event) {
        event.preventDefault(); 
  
        let targetTab = this.getAttribute("data-tab");
  
        tabLinks.forEach(t => t.classList.remove("active"));
        tabContents.forEach(c => c.classList.remove("active"));
  
        this.classList.add("active");
        document.getElementById(targetTab).classList.add("active");
      });
  });



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.

  document.querySelectorAll('[data-add-btn]').forEach((btn) => {
      btn.addEventListener('click', function () {
          // Find the closest 'data-add-to-cart' button within the same container or parent element
          const addToCartBtn = document.querySelector('[data-add-to-cart]');
  
          if (addToCartBtn) {
              addToCartBtn.click(); // Simulate click on "Add to Cart" button
              addToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); // Scroll smoothly to the button
          }
      });
  });


  
})();



